export const FINANCING_ENDING_GRID_CODE = 'financing-ending';
